// @ts-check

import { Stack, styled, ToggleButtonGroup, toggleButtonGroupClasses, ToggleButton, toggleButtonClasses, Icon } from '@mui/material';

export const InputContainer = styled(Stack)(({ theme }) => ({
    border: `2px solid ${theme.palette.common.lightgray}`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: '0px',
    cursor: 'default',
    borderRadius: '12px',
    '&:focus-within ': {
        border: `2px solid ${theme.palette.success.main}`
    }
}));
export const WizzyToolbarButton = styled(ToggleButton)(({ theme }) => ({
    color: theme.palette.common.gray,
    border: 'none',
    padding: '6px',
    borderRadius: '8px',
    fontSize: '10px',
    [`& .${toggleButtonClasses.disabled}`]: {},
    [`& .${toggleButtonClasses.selected}`]: {},
    [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]: {}
}));

export const WizzyButtonIcon = styled(Icon)(({ theme }) => ({
    fontSize: '20px'
}));

export const WizzyToolbar = styled(Stack)(({ theme }) => ({
    flexDirection: 'row',
    justifyContent: 'flex-start',
    color: 'common.black',
    gap: '2px',
    width: '100%',
    padding: '4px'
}));
